<template>
    <div class="email-input-root d-flex align-items-center">
        <BaseInput
            ref="emailInput"
            class="email-input flex-grow"
            :placeholder="$t('general.email')"
            type="email"
            :value="value"
            @input="handleChange"
            inputClass="input-comp"
        />
        <BaseButton
            variant="primary"
            class="enterBtn h-100"
            :class="{ disappear: hideBtn }"
            :tabIndex="hideBtn ? '-1' : undefined"
        >
            {{ $t('shared.loginModule.logIn') }}
        </BaseButton>
    </div>
</template>

<script>
export default {
    name: 'EmailInput',
    props: {
        value: String,
        hideBtn: Boolean,
    },
    methods: {
        handleChange(value) {
            this.$emit('input', value);
        },
        focus() {
            this.$refs.emailInput.focus();
        },
    },
};
</script>

<style scoped>
.email-input-root {
    height: 54px !important;
    border: thin solid #ddd !important;
    border-radius: 5px;
}
.email-input {
    border: none !important;
    outline: none !important;
    height: 100% !important;
}
/* Hei anders */
.input-comp {
    border: none !important;
}
.input-comp:focus {
    outline: none; /* rgba(0, 0, 0, 0.5); */
}

.enterBtn {
    color: white !important;
    height: 100% !important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    cursor: pointer;
    min-width: 75px;

    transition: all 0.3s;
}
.disappear {
    min-width: 0px;
    width: 0px !important;
    max-width: 0px;
    display: hidden;
    opacity: 0;
    padding: 0 !important;
    border: none;
}
</style>
